/**
 * Generates a random 16-character hexadecimal span ID.
 * This is used for creating new span IDs in distributed tracing.
 *
 * @returns A 16-character hexadecimal string
 *
 * @example
 * ```typescript
 * const spanId = generateSpanId(); // e.g., "84a67a1b3ceccf27"
 * ```
 */
export function generateSpanId(): string {
	return Array.from(new Array(16), () => Math.floor(Math.random() * 16).toString(16)).join('');
}
